import { ButtonIcon } from '../../../../../../components/inputs/button-icon/button-icon';
import { Input } from '../../../../../../components/inputs/input/input';
import IconEdit from '../../../../../../components/icons/icon-edit/icon-edit';
import IconApply from '../../../../../../components/icons/icon-apply/icon-apply';
import IconDiscard from '../../../../../../components/icons/icon-discard/icon-discard';
import { Tooltip } from '../../../../../../components/tooltip/tooltip';
import { TOOLTIP_PLACEMENTS } from '../../../../../../components/tooltip/tooltip-box';

import TooltipContent from './tooltip-content';

interface IQuotaSectionProps {
    featureId: number;
    hasQuota: boolean;
    quota?: string | null;
    isEditing: boolean;
    quotaValue: string;
    onStartEditing: (featureId: number, currentQuota?: string) => void;
    onCancelEditing: (featureId: number) => void;
    onApplyQuota: (featureId: number) => void;
    onQuotaChange: (featureId: number, value: any) => void;
    onSetQuota?: (featureId: number, quota: number) => void;
    isSettingQuota: boolean;
}

const QuotaSection: React.FC<IQuotaSectionProps> = ({
    featureId,
    hasQuota,
    quota,
    isEditing,
    quotaValue,
    onStartEditing,
    onCancelEditing,
    onApplyQuota,
    onQuotaChange,
    onSetQuota,
    isSettingQuota
}) => {
    if (isEditing) {
        return (
            <div className="quota-editing">
                <div className="quota-input-row">
                    <span className="quota-label">Quota:</span>
                    <Input
                        type="number"
                        value={quotaValue || '0'}
                        onChange={(value) => onQuotaChange(featureId, value)}
                        placeholder="Enter quota"
                        disabled={isSettingQuota}
                        min={0}
                        step={1.00}
                    />
                    <div className="quota-actions">
                        <div data-testid="quota-apply-button">
                            <ButtonIcon
                                Component={IconApply}
                                onClick={() => onApplyQuota(featureId)}
                                disabled={isSettingQuota}
                            />
                        </div>
                        <div data-testid="quota-cancel-button">
                            <ButtonIcon
                                Component={IconDiscard}
                                onClick={() => onCancelEditing(featureId)}
                                disabled={isSettingQuota}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (hasQuota || quota) {
        return (
            <div className="quota-display">
                <span className="feature-quota">
                    Quota: {quota || '0'}
                </span>
                {onSetQuota && (
                    <div data-testid="quota-edit-button">
                        <Tooltip
                            content={<TooltipContent content="Edit quota" />}
                            placement={TOOLTIP_PLACEMENTS.TOP}
                        >
                            <ButtonIcon
                                Component={IconEdit}
                                onClick={() => onStartEditing(featureId, quota || undefined)}
                                disabled={isSettingQuota}
                            />
                        </Tooltip>
                    </div>
                )}
                {isSettingQuota && (
                    <span className="setting-quota-indicator">Setting quota...</span>
                )}
            </div>
        );
    }

    return null;
};

export default QuotaSection;
